import request from '@/middleware/request'

const getCallById = id => {
  return request({
    url: `/call/${id}`,
    method: 'get'
  })
}

const getLatestCallByUserId = data => {
  return request({
    url: '/call/latestCallByUserId',
    method: 'post',
    data: data
  })
}

const callStart = data => {
  return request({
    url: '/call/start',
    method: 'post',
    data: data
  })
}

const callEnd = data => {
  return request({
    url: '/call/end',
    method: 'post',
    data: data
  })
}

const updateCallStatus = (callId, data) => {
  return request({
    url: `/call/updateCallStatus/${callId}`,
    method: 'patch',
    data: data
  })
}

const updateSessionNo = (callId, data) => {
  return request({
    url: `/call/updateSessionNo/${callId}`,
    method: 'patch',
    data: data
  })
}

const updateStatusBySessionNo = data => {
  return request({
    url: '/call/updateStatusBySessionNo',
    method: 'post',
    data: data
  })
}

export default {
  getLatestCallByUserId,
  getCallById,
  callStart,
  callEnd,
  updateCallStatus,
  updateSessionNo,
  updateStatusBySessionNo
}
